import React, { useEffect, useState } from "react";
import { FileUploader } from "../../Components/Common";

/*
formData => json of initial form data Key-DefaultValue pair
renderField => json of key - value which declares input type(SELECT, DATE, TEXT) and input type meta info if needed e.g.  { "key": { "type": "SELECT", "dropdownValues": ["1", "2", "3"] } }
handleChangeData => get calls on change of values of form fields
*/

const CommonForm = ({
  formData,
  renderField = null,
  handleChangeData = null,
  formFieldLabels = null,
  clearForm = false,
  isTwoColumnCss = "w-1/2 px-4",
  readOnly = false,
  readOnlyFields = [],
  isSubmitting = false,
  onNewFilesChange,
}) => {
  const [updatedFormData, setUpdatedFormData] = useState(formData);
  const [newFiles, setNewFiles] = useState({});

  useEffect(() => {
    setUpdatedFormData(formData);
  }, [clearForm]);

  const handleChange = (fieldName, value) => {
    handleChangeData(fieldName, value);
    setUpdatedFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
  };

  const readOnlyCss = "bg-gray-50 border border-gray-200 text-gray-500";

  return (
    <div className="w-full max-h-[80vh] overflow-y-auto">
      <div className="flex flex-wrap">
        {Object.entries(updatedFormData)
          .filter(
            ([fieldName]) => renderField === null || renderField[fieldName]
          )
          .map(([fieldName, fieldValue], index) => (
            <div key={index} className={isTwoColumnCss}>
              <div key={index} className="mt-2">
                {renderField === null ? (
                  <label
                    htmlFor={fieldName}
                    className="mb-3 mt-4 pl-1 text-sm font-medium text-gray-900"
                  >
                    {formFieldLabels && formFieldLabels[fieldName]
                      ? formFieldLabels[fieldName]
                      : fieldName}
                  </label>
                ) : renderField[fieldName].type === "HIDE" ||
                  renderField[fieldName].type === "CHECKBOX" ? (
                  <></>
                ) : (
                  <label
                    htmlFor={fieldName}
                    className="mb-3 mt-4 pl-1 text-sm font-medium text-gray-900"
                  >
                    {formFieldLabels && formFieldLabels[fieldName]
                      ? formFieldLabels[fieldName]
                      : fieldName}
                  </label>
                )}
                {renderField === null ? (
                  <div className="mt-1">
                    <input
                      type="text"
                      id={fieldName}
                      name={fieldName}
                      value={updatedFormData[fieldName]}
                      onChange={(e) => handleChange(fieldName, e.target.value)}
                      required
                      disabled={
                        isSubmitting ||
                        readOnly ||
                        readOnlyFields.includes(fieldName)
                      }
                      className={` text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ${
                        readOnly || readOnlyFields.includes(fieldName)
                          ? readOnlyCss
                          : "bg-gray-50 border border-gray-400 text-gray-900"
                      }`}
                    />
                  </div>
                ) : (
                  (() => {
                    switch (renderField[fieldName].type) {
                      case "SELECT":
                        return (
                          <div>
                            <select
                              id={fieldName}
                              name={fieldName}
                              value={updatedFormData[fieldName]}
                              onChange={(e) =>
                                handleChange(fieldName, e.target.value)
                              }
                              disabled={
                                isSubmitting ||
                                readOnly ||
                                readOnlyFields.includes(fieldName)
                              }
                              className={` text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ${
                                readOnly || readOnlyFields.includes(fieldName)
                                  ? readOnlyCss
                                  : "bg-gray-50 border border-gray-400 text-gray-900"
                              }`}
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              {renderField[fieldName].dropdownValues?.map(
                                (option, index) => (
                                  <option key={index} value={option}>
                                    {formFieldLabels && formFieldLabels[option]
                                      ? formFieldLabels[option]
                                      : option}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        );
                      case "DATE":
                        return (
                          <div>
                            <input
                              type="date"
                              value={updatedFormData[fieldName]}
                              disabled={
                                isSubmitting ||
                                readOnly ||
                                readOnlyFields.includes(fieldName)
                              }
                              onChange={(e) =>
                                handleChange(fieldName, e.target.value)
                              }
                              className="p-2 w-full text-md sm:text-sm text-gray-900 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                            />
                          </div>
                        );
                      case "TEXT":
                        return (
                          <div>
                            <input
                              type="text"
                              id={fieldName}
                              name={fieldName}
                              value={updatedFormData[fieldName]}
                              disabled={
                                isSubmitting ||
                                readOnly ||
                                readOnlyFields.includes(fieldName)
                              }
                              onChange={(e) =>
                                handleChange(fieldName, e.target.value)
                              }
                              className={` text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ${
                                readOnly || readOnlyFields.includes(fieldName)
                                  ? readOnlyCss
                                  : "bg-gray-50 border border-gray-400 text-gray-900"
                              }`}
                            />
                          </div>
                        );
                      case "CHECKBOX":
                        return (
                          <div className="flex mt-3">
                            <input
                              type="checkbox"
                              id={fieldName}
                              name={fieldName}
                              disabled={
                                isSubmitting ||
                                readOnly ||
                                readOnlyFields.includes(fieldName)
                              }
                              value={updatedFormData[fieldName]}
                              onChange={(e) =>
                                handleChange(fieldName, e.target.checked)
                              }
                              className={`mt-1 text-blue-500 text-sm rounded-md block p-2 ${
                                readOnly || readOnlyFields.includes(fieldName)
                                  ? readOnlyCss
                                  : "bg-gray-50 border border-gray-400 text-gray-900"
                              }`}
                            />
                            <label
                              htmlFor={fieldName}
                              className="mb-3 pl-1 text-sm font-medium text-gray-900"
                            >
                              {formFieldLabels && formFieldLabels[fieldName]
                                ? formFieldLabels[fieldName]
                                : fieldName}
                            </label>
                          </div>
                        );
                      case "HIDE":
                        return null;
                      case "FILE":
                        return (
                          <div className="flex flex-col gap-2">
                            {/* If file already exists, show preview */}
                            {updatedFormData[fieldName] &&
                            typeof updatedFormData[fieldName] === "string" ? (
                              <div className="flex flex-col items-center gap-2">
                                <label className="mb-1 text-sm font-medium text-gray-900">
                                  Current File
                                </label>
                                <img
                                  src={updatedFormData[fieldName]}
                                  alt="Uploaded"
                                  className="max-h-40 object-contain border rounded"
                                />
                              </div>
                            ) : (
                              <span className="text-sm text-gray-500 italic">
                                No file uploaded yet
                              </span>
                            )}

                            {/* File Upload Component */}
                            <div className="flex gap-2">
                              <FileUploader
                                label={"Upload File"}
                                accept="image/*"
                                disabled={isSubmitting}
                                singleButton={true}
                                btnText={
                                  updatedFormData[fieldName]
                                    ? "Replace File"
                                    : "Add File"
                                }
                                onUploadClick={(file) => {
                                  setNewFiles((prev) => {
                                    const updated = {
                                      ...prev,
                                      [fieldName]: file,
                                    };
                                    return updated;
                                  });
                                  handleChange(fieldName, file);
                                }}
                              />

                              {newFiles[fieldName] && (
                                <span className="text-xs text-secondary italic mt-10">
                                  Click on Save to Add/Replace File
                                </span>
                              )}
                            </div>
                          </div>
                        );
                      default:
                        return (
                          <p className="text-red-500 text-sm">
                            Form field input type is not defined
                          </p>
                        );
                    }
                  })()
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CommonForm;
